export const convertYearToDate = (year: number) => {
  return new Date(year, 0, 1);
};

export const addYears = (date: number | string | Date, years: number) => {
  const newDate = new Date(date);
  newDate.setFullYear(newDate.getFullYear() + years);
  return newDate;
};

export const addMonths = (date: number | string | Date, months: number) => {
  const newDate = new Date(date);
  newDate.setMonth(newDate.getMonth() + months);
  return newDate;
};

export const resetYear = (date: number | string | Date) => {
  const newDate = new Date(date);
  newDate.setFullYear(newDate.getFullYear(), 0, 1);
  return newDate;
};
